import { Controller } from 'stimulus';

class Cards extends Controller {

  initialize() {
    const _this = this;
    this.cardItem = this.element;
    this.imageHeight = this.imageTarget.offsetHeight;
    this.headlineMargin = parseInt(window.getComputedStyle(this.headlineTarget).marginBottom, 10);
    this.bottomHeight = this.bottomTarget.offsetHeight;
    const cardHeight = this.bottomHeight + this.imageHeight;
    this.cardItem.style.maxHeight = `${cardHeight}px`;
    
    this.cardItem.addEventListener('mouseenter', addActive);
    this.cardItem.firstElementChild.addEventListener('focus', addActive);
    this.cardItem.addEventListener('mouseleave', removeActive);
    this.cardItem.firstElementChild.addEventListener('blur', removeActive);

    function addActive() {
      _this.cardItem.classList.add('active');
    }
    function removeActive() {
      _this.cardItem.classList.remove('active');
    }
  }
}

Cards.targets = ['button', 'image', 'bottom', 'body', 'wrapper', 'headline'];

export default Cards;
